export enum FinishTransferModalTestIds {
  TRANSFER = 'finish_transfer',
}
